<template>

    <div class="th-menu-wrapper">
        <div class="th-menu-area text-center"><button class="th-menu-toggle"><i class="fal fa-times"></i></button>
            <div class="mobile-logo"><a href="index"><img src="assets/img/logo.png" alt="大唐思拓"></a></div>
            <div class="th-mobile-menu" style="display: block!important;">
                <ul>
                    <li class="active"><a href="index">网站首页</a></li>

                    <li class="menu-item-has-children"><a href="#">解决方案</a>
                        <ul class="sub-menu submenurow" id="jjfa">
                            <li> <strong>行业解决方案</strong>
                                <a href="solutiona.html">火电管控解决方案</a>
                                <a href="solutionb.html">水电管控解决方案</a>
                                <a href="solutionc.html">风电管控解决方案</a>
                                <a href="solutiond.html">燃机发电管控解决方案</a>
                                <a href="solutione.html">中小水电管控解决方案</a>
                                <a href="solutionf.html">化工企业管控解决方案</a>
                            </li>
                            <li> <strong>领域解决方案</strong>
                                <a href="solution1.html">安全生产智慧管控方案</a>
                                <a href="solution2.html">智慧安防解决方案</a>
                                <a href="solution2b.html">安健环数字化管理解决方案</a>
                                <a href="solution3.html">智慧工地解决方案</a>
                                <a href="solution4.html">风机智慧定检解决方案</a>
                                <a href="solution5.html">智能两票解决方案</a>
                                <a href="solution6.html">智慧外包解决方案</a>
                                <a href="solution7.html">双重预控智能管理方案</a>
                                <a href="solution8.html">作业安全智能管控解决方案</a>
                                <a href="solution9.html">智能锁控解决方案</a>
                                <a href="solution10.html">有限空间作业智能管控方案</a>
                                <a href="solution11.html">设备缺陷智能分析解决方案</a>
                                <a href="solution12.html">在线考试管理解决方案</a>
                                <a href="solution13.html">智慧食堂一体化解决方案</a>
                            </li>
                        </ul>
                    </li>
                    <li class="menu-item-has-children"><a href="#">产品与服务</a>
                        <ul class="sub-menu">
                            <li> <strong>基础模块</strong>
                                <a href="product1.html">生产任务管理</a>
                                <a href="product2.html">设备管理</a>
                                <a href="product3.html">运行管理</a>
                                <a href="product4.html">安全管理</a>
                                <a href="product5.html">班组管理</a>
                                <a href="product6.html">物资管理</a>
                                <a href="product7.html">问题管理</a>
                                <a href="product8.html">在线考试管理</a>
                                <a href="product9.html">职业健康管理</a>
                                <a href="product10.html">标准制度管理</a>
                                <a href="product11.html">案例库管理</a>
                            </li>
                            <li> <strong>增值服务</strong>
                                <a href="product12.html">智能两票管理</a>
                                <a href="product13.html">智慧外包管理</a>
                                <a href="product14.html">智能点检管理</a>
                                <a href="product15.html">全员绩效管理</a>
                                <a href="product16.html">风险评估管理</a>
                                <a href="product17.html">安全生产责任制</a>
                                <strong>特色模块</strong>
                                <a href="product18.html">AI视频分析及预警</a>
                                <a href="product19.html">实时定位和监控</a>
                                <a href="product20.html">智能门禁管理</a>
                                <a href="product21.html">智能锁控管理</a>
                                <a href="product22.html">智能穿戴设备</a>
                                <a href="product23.html">数据采集管理</a>
                            </li>
                        </ul>
                    </li>
                    <li class="menu-item-has-children"><a href="#">客户</a>
                        <ul class="sub-menu submenurow">
                            <li> <strong>典型案例</strong>
                                <a href="client1.html">安全生产管控</a>
                                <a href="client2.html">企业标准化管理</a>
                                <a href="client3.html">全员绩效管理</a>
                                <a href="client4.html">其他管控</a>
                            </li>
                            <li> <strong>增值服务</strong>
                                <a href="client5.html">火电企业客户</a>
                                <a href="client5.html#parta">水电企业客户</a>
                                <a href="client5.html#partb">风电企业客户</a>
                                <a href="client5.html#partc">电网公司客户</a>
                                <a href="client5.html#partd">化工企业客户</a>
                            </li>
                        </ul>
                    </li>
                    <li class="menu-item-has-children"><a href="#">服务</a>
                        <ul class="sub-menu submenurow">
                            <li> <strong>服务与支持</strong>
                                <a href="service1.html">产品实施</a>
                                <a href="service2.html">产品部署</a>
                                <a href="service3.html">常见问题</a>
                            </li>

                        </ul>
                    </li>
                    <li class="menu-item-has-children"><a href="#">商业合作</a>
                        <ul class="sub-menu submenurow">
                            <li> <strong>商业合作</strong>
                                <a href="cooperation.html">合作方式</a>
                                <a href="apply">在线申请</a>
                            </li>
                        </ul>
                    </li>
                    <li><a href="news">新闻动态</a></li>
                    <li><a href="about.html">关于我们</a></li>
                </ul>
            </div>
        </div>
    </div>
    <header class="th-header header-layout3">
        <div class="container">
            <div class="header-top">
                <div class="row justify-content-center justify-content-lg-between align-items-center gy-2">
                    <div class="col-auto d-none d-lg-block">
                        <div class="header-links">
                            <ul>

                                <li class="d-none d-xl-inline-block"><i class="far fa-location-dot"></i>北京市西城区新街口外大街
                                    28号C座 302 室</li>
                                <li><i class="far fa-phone"></i><a href="tel:4006988915">400-6988-915</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="header-links header-right">
                            <ul>
                                <li>
                                    <div class="header-social"><span class="social-title">社交媒体:</span> <a
                                            href="about.html#Contact"><i class="fab fa-weibo"></i></a> <a
                                            href="about.html#Contact"><i class="fab fa-weixin"></i></a></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sticky-wrapper">
            <div class="container">
                <div class="menu-area">
                    <div class="row align-items-center justify-content-between">
                        <div class="col-auto">
                            <div class="header-logo"><a href="index"><img src="assets/img/logo.png" alt="大唐思拓"></a>
                            </div>
                        </div>
                        <div class="col-auto me-lg-auto">
                            <nav class="main-menu d-none d-lg-inline-block">
                                <ul>
                                    <li class="active"><a href="index">网站首页</a></li>
                                    <li class="menu-item-has-children"><a href="#">解决方案</a>
                                        <ul class="sub-menu submenurow" id="jjfa">
                                            <li> <strong>行业解决方案</strong>
                                                <a href="solutiona.html">火电管控解决方案</a>
                                                <a href="solutionb.html">水电管控解决方案</a>
                                                <a href="solutionc.html">风电管控解决方案</a>
                                                <a href="solutiond.html">燃机发电管控解决方案</a>
                                                <a href="solutione.html">中小水电管控解决方案</a>
                                                <a href="solutionf.html">化工企业管控解决方案</a>
                                            </li>
                                            <li> <strong>领域解决方案</strong>
                                                <a href="solution1.html">安全生产智慧管控方案</a>
                                                <a href="solution2.html">智慧安防解决方案</a>
                                                <a href="solution2b.html">安健环数字化管理解决方案</a>
                                                <a href="solution3.html">智慧工地解决方案</a>
                                                <a href="solution4.html">风机智慧定检解决方案</a>
                                                <a href="solution5.html">智能两票解决方案</a>
                                                <a href="solution6.html">智慧外包解决方案</a>
                                                <a href="solution7.html">双重预控智能管理方案</a>
                                                <a href="solution8.html">作业安全智能管控解决方案</a>
                                                <a href="solution9.html">智能锁控解决方案</a>
                                                <a href="solution10.html">有限空间作业智能管控方案</a>
                                                <a href="solution11.html">设备缺陷智能分析解决方案</a>
                                                <a href="solution12.html">在线考试管理解决方案</a>
                                                <a href="solution13.html">智慧食堂一体化解决方案</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li class="menu-item-has-children"><a href="#">产品与服务</a>
                                        <ul class="sub-menu submenurow">
                                            <li> <strong>基础模块</strong>
                                                <a href="product1.html">生产任务管理</a>
                                                <a href="product2.html">设备管理</a>
                                                <a href="product3.html">运行管理</a>
                                                <a href="product4.html">安全管理</a>
                                                <a href="product5.html">班组管理</a>
                                                <a href="product6.html">物资管理</a>
                                                <a href="product7.html">问题管理</a>
                                                <a href="product8.html">在线考试管理</a>
                                                <a href="product9.html">职业健康管理</a>
                                                <a href="product10.html">标准制度管理</a>
                                                <a href="product11.html">案例库管理</a>
                                            </li>
                                            <li> <strong>增值服务</strong>
                                                <a href="product12.html">智能两票管理</a>
                                                <a href="product13.html">智慧外包管理</a>
                                                <a href="product14.html">智能点检管理</a>
                                                <a href="product15.html">绩效管理</a>
                                                <a href="product16.html">风险评估</a>
                                                <a href="product17.html">责任制评价</a>
                                                <strong>特色模块</strong>
                                                <a href="product18.html">AI视频分析及预警</a>
                                                <a href="product19.html">实时定位和监控</a>
                                                <a href="product20.html">智能门禁管理</a>
                                                <a href="product21.html">智能锁控管理</a>
                                                <a href="product22.html">智能穿戴设备</a>
                                                <a href="product23.html">数据采集管理</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li class="menu-item-has-children"><a href="#">客户</a>
                                        <ul class="sub-menu submenurow">
                                            <li> <strong>典型案例</strong>
                                                <a href="client1.html">安全生产管控</a>
                                                <a href="client2.html">企业标准化管理</a>
                                                <a href="client3.html">全员绩效管理</a>
                                                <a href="client4.html">其他管控</a>
                                            </li>
                                            <li> <strong>增值服务</strong>
                                                <a href="client5.html">火电企业客户</a>
                                                <a href="client5.html#parta">水电企业客户</a>
                                                <a href="client5.html#partb">风电企业客户</a>
                                                <a href="client5.html#partc">电网公司客户</a>
                                                <a href="client5.html#partd">化工企业客户</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li class="menu-item-has-children"><a href="#">服务</a>
                                        <ul class="sub-menu submenurow">
                                            <li> <strong>服务与支持</strong>
                                                <a href="service1.html">产品实施</a>
                                                <a href="service2.html">产品部署</a>
                                                <a href="service3.html">常见问题</a>
                                            </li>

                                        </ul>
                                    </li>

                                    <li class="menu-item-has-children"><a href="#">商业合作</a>
                                        <ul class="sub-menu submenurow">
                                            <li> <strong>商业合作</strong>
                                                <a href="cooperation.html">合作方式</a>
                                                <a href="apply">在线申请</a>

                                            </li>

                                        </ul>
                                    </li>
                                    <li><a href="news">新闻动态</a></li>
                                    <li><a href="about.html">关于我们</a></li>
                                </ul>
                            </nav><button type="button" class="th-menu-toggle d-block d-lg-none"><i
                                    class="far fa-bars"></i></button>
                        </div>
                        <div class="col-auto d-none d-xl-block">
                            <div class="header-button"> <a href="about.html" class="th-btn style3 ml-15">联系我们 <i
                                        class="fas fa-arrow-right ms-1"></i></a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <a-carousel arrows class="banner">
        <template #prevArrow>
            <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
                <left-circle-outlined />
            </div>
        </template>
        <template #nextArrow>
            <div class="custom-slick-arrow" style="right: 10px">
                <right-circle-outlined />
            </div>
        </template>
        <div class="carousel1">
            <h3>
                <p>Intelligent Guardianship for Security, Innovation Leads the Future</p> 智能守护安全 创新引领未来
                <div><a href="solution1.html" class="th-btn style3 ml-15">了解更多 <i
                            class="fas fa-arrow-right ms-1"></i></a></div>
            </h3>
        </div>
        <div class="carousel2">
            <h3>
                <p>More intelligent, more efficient, more secure, more reliable</p>更智能 &nbsp;更高效 &nbsp;更安全 &nbsp;更可靠
                <div><a href="solution1.html" class="th-btn style3 ml-15">了解更多 <i
                            class="fas fa-arrow-right ms-1"></i></a></div>
            </h3>
        </div>
        <div class="carousel3">
            <h3>
                <p>Trusted Leader in Intelligent Security</p>值得信赖的智能安全领航者
                <div><a href="solution1.html" class="th-btn style3 ml-15">了解更多 <i
                            class="fas fa-arrow-right ms-1"></i></a></div>
            </h3>
        </div>
        <div class="carousel4">
            <h3>
                <p>Promote customers to achieve high-quality development and high-level security, and create a bright
                    future
                    together!</p>推动客户实现高质量发展和高水平安全，共创美好未来！
                <div><a href="solution1.html" class="th-btn style3 ml-15">了解更多 <i
                            class="fas fa-arrow-right ms-1"></i></a></div>
            </h3>
        </div>
    </a-carousel>


    <!-- <div class="container">
        <div class="feature-area-2">
            <div class="row th-carousel g-0 justify-content-center" data-slide-show="3" data-lg-slide-show="2"
                data-md-slide-show="2">
                <div class="col-lg-4 col-md-6">
                    <div class="feature-card2 hover-item">
                        <div class="feature-card2-icon"><img src="assets/img/icon/feature-icon2-1.svg" alt="Icon"></div>
                        <div class="media-body">
                            <h3 class="box-title"><a href="service.html">基础模块</a></h3>
 <p class="feature-card2-text" style=" text-align: justify; line-height: 22px;">生产任务管理，设备管理，运行管理，安全管理，班组管理，物资管理，问题管理，在线考试管理，职业健康管理，标准制度管理，案例库管理。</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="feature-card2 hover-item item-active">
                        <div class="feature-card2-icon"><img src="assets/img/icon/feature-icon2-2.svg" alt="Icon"></div>
                        <div class="media-body">
                            <h3 class="box-title"><a href="service.html">增值服务</a></h3>
                            <p class="feature-card2-text">智能两票管理，智慧外包管理，智能点检管理，绩效管理，风险评估，责任制评价。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="feature-card2 hover-item">
                        <div class="feature-card2-icon"><img src="assets/img/icon/feature-icon2-3.svg" alt="Icon"></div>
                        <div class="media-body">
                            <h3 class="box-title"><a href="service.html">特色模块</a></h3>
                            <p class="feature-card2-text">AI视频分析及预警，实时定位和监控，智能门禁管理，智能锁控管理，智能穿戴，数据采集管理。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="th-container6 space-extra-top space-bottom" id="about">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="img-box11">
                        <div class="img1"><img class="tilt-active" src="assets/img/update1/normal/about_3_1.jpg"
                                alt="About"></div>
                        <div class="text-end">
                            <div class="img2"><img class="tilt-active" src="assets/img/update1/normal/about_3_2.jpg"
                                    alt="About"></div>
                        </div>
                        <div class="shape1"><img src="assets/img/update1/shape/about_3_1.png" alt="About"></div>
                        <div class="shape2"><img src="assets/img/update1/shape/about_3_2.png" alt="About"></div>
                    </div>
                </div>
                <div class="col-xl-6 ps-xxl-5">
                    <div class="title-area mb-30">
                        <div class="shadow-title" style="font-size: 120px;">大唐思拓</div><span class="sub-title6">大唐思拓<span
                                class="shape right"><span class="dots"></span></span></span>
                        <h2 class="sec-title">智能守护安全<br>创新引领未来</h2>
                    </div>
                    <p class="mt-n2 mb-4">
                        大唐思拓成立于2006年4月，是一家专注于智能安全管控技术与解决方案研发的高科技企业，国家级“双软认证”和“高新技术企业”，致力于以优质的产品和服务推动企业安全管理升级、智能化改造、经济增长和社会进步。
                    </p>
                    <div class="about-feature">
                        <div class="about-feature_icon"><img src="assets/img/update1/icon/a_feature_1_1.svg" alt="icon">
                        </div>
                        <div>
                            <!--<h3 class="about-feature_title">人工智能 大数据 物联网</h3>-->

                            <p class="about-feature_text">
                                我们始终秉承“智能守护安全、创新引领未来”的理念，融合人工智能、物联网、云计算、大数据及5G技术，为企业提供覆盖多场景的智能安全产品及一体化解决方案，涵盖安全生产、风险管理、设备运维、作业管理、培训管理等领域。<a
                                    href="about.html">了解更多<i class="fas fa-arrow-right ms-2"></i></a></p>
                        </div>
                    </div>
                    <div class="about-feature">
                        <div class="about-feature_icon"><img src="assets/img/update1/icon/a_feature_1_2.svg" alt="icon">
                        </div>
                        <div>
                            <!--<h3 class="about-feature_title">安全生产 智慧安防 双重预控 </h3>-->
                            <p class="about-feature_text">
                                大唐思拓致力于推动工业化与数字化的深度融合，加速企业数字化转型，以创新技术守护企业安全，提升管理效率，实现高水平安全和高质量发展，助力智慧企业建设。<a
                                    href="solution1.html">了解更多<i class="fas fa-arrow-right ms-2"></i></a></p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>


    <section class="space overflow-hidden" data-bg-src="assets/img/update1/bg/service_bg_3.jpg" id="product-home">
        <div class="container">
            <div class="title-area text-center"><span class="sub-title6 justify-content-center"><span
                        class="shape left"><span class="dots"></span></span> Product Introduction <span
                        class="shape right"><span class="dots"></span></span></span>
                <h2 class="sec-title">产品介绍</h2>
            </div>
            <div class="row gx-0">
                <div class="col-md-6 col-lg-4 service-list-wrap">
                    <div class="service-list">
                        <div class="service-list_icon"><img src="assets/img/update1/icon/service_4_1.svg" alt="Icon">
                        </div>
                        <div class="service-list_content">
                            <h3 class="service-list_title box-title" data-bs-toggle="modal"
                                data-bs-target="#serviceModal">
                                本质安全数字化智能化管控平台</h3>
                            <p class="service-list_text">
                                本质安全数字化智能化管控平台，融合人工智能、大数据和物联网技术，创新性地实现了安全生产和价值创造的全方位智能化管理。平台通过实时数据采集和智能分析，提供高效、可靠的风险预警和管控方案，优化业务流程，提高生产效率，助力企业在保障高水平安全的同时，实现可持续的价值创造，推动高质量发展。
                            </p><a href="solution1.html" class="service-list_btn"><i
                                    class="fas fa-arrow-right icon-btn"></i>了解更多</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 service-list-wrap">
                    <div class="service-list">
                        <div class="service-list_icon"><img src="assets/img/update1/icon/service_4_2.svg" alt="Icon">
                        </div>
                        <div class="service-list_content">
                            <h3 class="service-list_title box-title" data-bs-toggle="modal"
                                data-bs-target="#serviceModal">
                                双重预防智能管控平台</h3>
                            <p class="service-list_text">
                                双重预防智能管控平台，旨在通过融合人工智能、大数据分析和移动互联技术，实现风险动态识别与评估，对安全风险分级管控与隐患排查治理进行全过程数字化、智能化管理，在大幅减轻工作量的同时，保障企业安全生产和高质量发展。
                            </p><a href="solution3.html" class="service-list_btn"><i
                                    class="fas fa-arrow-right icon-btn"></i>了解更多</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 service-list-wrap">
                    <div class="service-list">
                        <div class="service-list_icon"><img src="assets/img/update1/icon/service_4_3.svg" alt="Icon">
                        </div>
                        <div class="service-list_content">
                            <h3 class="service-list_title box-title" data-bs-toggle="modal"
                                data-bs-target="#serviceModal">
                                作业风险智能管控与反违章平台</h3>
                            <p class="service-list_text">
                                作业风险智能管控与反违章平台，专为高风险行业设计的智能安全管控系统，致力于通过智能技术对生产企业的风险识别与隐患排查进行全生命周期数字化管理。平台支持智能穿戴设备和电子围栏功能，精准监测作业人员状态与环境安全；通过自动化分析与流程闭环管控，大幅提升企业安全管理效能，助力降低事故率、优化管理模式，实现安全生产与高质量发展双目标。
                            </p><a href="solution4.html" class="service-list_btn"><i
                                    class="fas fa-arrow-right icon-btn"></i>了解更多</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 service-list-wrap">
                    <div class="service-list">
                        <div class="service-list_icon"><img src="assets/img/update1/icon/service_4_4.svg" alt="Icon">
                        </div>
                        <div class="service-list_content">
                            <h3 class="service-list_title box-title" data-bs-toggle="modal"
                                data-bs-target="#serviceModal">
                                有限空间作业智能管控平台</h3>
                            <p class="service-list_text">
                                有限空间作业智能管控平台，结合智能穿戴设备、环境监测系统、人工智能技术，专为石油化工、电力、矿山等高风险行业设计的智能化管理平台。通过实时监控作业环境与人员状态，平台快速识别潜在风险、精准预警与应急响应。覆盖从作业申请到执行的闭环流程，支持离线作业和数据同步，显著降低作业风险、提升管理效率，保障作业安全与合规。
                            </p><a href="solution2.html" class="service-list_btn"><i
                                    class="fas fa-arrow-right icon-btn"></i>了解更多</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 service-list-wrap">
                    <div class="service-list">
                        <div class="service-list_icon"><img src="assets/img/update1/icon/service_4_6.svg" alt="Icon">
                        </div>
                        <div class="service-list_content">
                            <h3 class="service-list_title box-title" data-bs-toggle="modal"
                                data-bs-target="#serviceModal">
                                智慧外包管控平台</h3>
                            <p class="service-list_text">
                                智慧外包管控平台，结合人工智能、大数据和物联网技术，覆盖外包单位资质审核、人员管理、安全培训、门禁授权和作业现场动态监控全流程。通过智能门禁与“人帽一体”管理模式，精准管控作业人员，确保合规与安全。平台实现在线审批、实时监控和动态预警，有效提升管理效率、降低安全风险，为企业外包工程管理提供智能化解决方案。
                            </p><a href="solution7.html" class="service-list_btn"><i
                                    class="fas fa-arrow-right icon-btn"></i>了解更多</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 service-list-wrap">
                    <div class="service-list">
                        <div class="service-list_icon"><img src="assets/img/update1/icon/service_4_5.svg" alt="Icon">
                        </div>
                        <div class="service-list_content">
                            <h3 class="service-list_title box-title" data-bs-toggle="modal"
                                data-bs-target="#serviceModal">
                                智能两票管理系统</h3>
                            <p class="service-list_text">
                                智能两票管理系统，专注于工作票与操作票的全流程数字化管理，通过人工智能与物联网技术，实现两票管理从开票到归档的全程电子化，杜绝纸质票。平台集成智能钥匙、智能接地线、智能门禁和人员定位等模块，提供实时数据联动与自动闭锁控制，保障安全合规。系统有效提升审批效率，降低误操作风险，并支持多方协同与审计管理，确保作业全程透明可控。
                            </p><a href="solution7.html" class="service-list_btn"><i
                                    class="fas fa-arrow-right icon-btn"></i>了解更多</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center mt-5"><a href="#solution-home" class="th-btn style-new">了解解决方案</a></div>
        </div>
    </section>
    <section class="space-top" id="solution-home">
        <div class="container" data-pos-space="#about-sec" data-sec-space="margin-bottom" data-margin-bottom="100px">
            <div class="title-area text-center">
                <div class="shadow-title">解决方案</div><span class="sub-title6 justify-content-center"><span
                        class="shape left"><span class="dots"></span></span> 解决方案一 <span class="shape right"><span
                            class="dots"></span></span></span>
                <h2 class="sec-title">安全生产智能管控方案</h2>
            </div>



            <a-carousel class="iconcarousel" :slidesToShow="slidesToShow" :slidesToScroll="1" :arrows="!isMobile">
                <template #prevArrow>
                    <div class="custom-slick-arrow-left">
                        <left-outlined />
                    </div>
                </template>
                <template #nextArrow>
                    <div class="custom-slick-arrow-right">
                        <right-outlined />
                    </div>
                </template>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_2.svg"
                                    alt="Icon">
                            </div>
                            <h2 class="service-box2_title"><a href="solution1.html">实时数据采集</a>
                            </h2>
                            <p class="service-box2_text">
                                通过物联网设备实时采集生产、设备、环境等多维度数据，确保信息全面、准确。
                            </p>
                        </div><a href="solution1.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>

                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_3.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution1.html">智能风险预警</a>
                            </h3>
                            <p class="service-box2_text">
                                利用AI技术进行数据分析和风险识别，提供即时预警和处理建议，有效防范潜在安全隐患。
                            </p>
                        </div><a href="solution1.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_4.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution1.html">设备全生命周期管理
                                </a>
                            </h3>
                            <p class="service-box2_text">实现设备从采购、运行到维护的全生命周期管理，确保设备健康状态和高效运行，降低维护成本。
                            </p>
                        </div><a href="solution1.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_1.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution1.html">安全态势一体化感知</a>
                            </h3>
                            <p class="service-box2_text">
                                构建全域安全态势感知平台，实时监控现场作业、人员分布和设备状态，实现全方位的安全管控。
                            </p>
                        </div><a href="solution1.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_2.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution1.html">应急响应和处置</a>
                            </h3>
                            <p class="service-box2_text">
                                建立智能应急响应系统，快速识别和处理突发事件，保障人员安全和生产连续性。
                            </p>
                        </div><a href="solution1.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_3.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution1.html">价值创造</a>
                            </h3>
                            <p class="service-box2_text">
                                通过优化业务流程和提高生产效率，实现企业的可持续发展和长远价值创造，提升企业在市场中的竞争力和盈利能力。
                            </p>
                        </div><a href="solution1.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
            </a-carousel>





        </div>

    </section>


    <section class="bg-smoke space overflow-hidden" data-bg-src="assets/img/update1/bg/service_bg_1.png"
        id="solution-home2">
        <div class="container">
            <div class="row justify-content-lg-between align-items-end">
                <div class="col-lg-7 mb-n2 mb-lg-0">
                    <div class="title-area"><span class="sub-title6">解决方案二 <span class="shape right"><span
                                    class="dots"></span></span></span>
                        <h2 class="sec-title">双重预防智能管控平台</h2>
                    </div>
                </div>
                <div class="col-auto">
                    <div class="sec-btn"><a href="solution2.html" class="th-btn">查看详情<i
                                class="fas fa-arrow-right ms-2"></i></a></div>
                </div>
            </div>

            <a-carousel class="iconcarousel iconcarouselb" :slidesToShow="slidesToShow" :slidesToScroll="1"
                :arrows="!isMobile">
                <template #prevArrow>
                    <div class="custom-slick-arrow-left">
                        <left-outlined />
                    </div>
                </template>
                <template #nextArrow>
                    <div class="custom-slick-arrow-right">
                        <right-outlined />
                    </div>
                </template>
                <div class="service-card2">
                    <div class="service-card2_img"><img src="assets/img/update1/service/service_1_2_v2.jpg"
                            alt="service image"></div>
                    <div class="service-card2_content" data-bg-src="assets/img/update1/bg/bg_pattern_5.png">
                        <h3 class="service-card2_title"><a href="solution7.html">全面数字化管理</a>
                        </h3>
                        <p class="service-card2_text">
                            实现从风险辨识、评估到管控措施的全过程数字化管理，提高效率，减少人为错误，确保风险无遗漏。
                        </p>
                        <div class="service-card2_icon"><img src="assets/img/update1/icon/service_1_1.svg" alt="Icon">
                        </div>
                    </div><a href="solution7.html" class="service-card2_btn"><i class="far fa-long-arrow-right"></i></a>
                </div>
                <div class="service-card2">
                    <div class="service-card2_img"><img src="assets/img/update1/service/service_1_1_v2.jpg"
                            alt="service image"></div>
                    <div class="service-card2_content" data-bg-src="assets/img/update1/bg/bg_pattern_5.png">
                        <h3 class="service-card2_title"><a href="solution7.html">风险动态识别与评估</a></h3>
                        <p class="service-card2_text">
                            利用人工智能和大数据分析技术，实动态识别和评估风险，即时预警，动态调整，确保安全生产。

                        </p>
                        <div class="service-card2_icon"><img src="assets/img/update1/icon/service_1_2.svg" alt="Icon">
                        </div>
                    </div><a href="solution7.html" class="service-card2_btn"><i class="far fa-long-arrow-right"></i></a>
                </div>

                <div class="service-card2">
                    <div class="service-card2_img"><img src="assets/img/update1/service/service_1_3_v2.jpg"
                            alt="service image"></div>
                    <div class="service-card2_content" data-bg-src="assets/img/update1/bg/bg_pattern_5.png">
                        <h3 class="service-card2_title"><a href="solution7.html">智能联动机制</a>
                        </h3>
                        <p class="service-card2_text">
                            作业与视频智能联动，实现对作业现场的实时监控，及时发现和纠正违章行为，建立系统全面、动态更新的风险库。

                        </p>
                        <div class="service-card2_icon"><img src="assets/img/update1/icon/service_1_3.svg" alt="Icon">
                        </div>
                    </div><a href="solution7.html" class="service-card2_btn"><i class="far fa-long-arrow-right"></i></a>
                </div>
                <div class="service-card2">
                    <div class="service-card2_img"><img src="assets/img/update1/service/service_1_4_v2.jpg"
                            alt="service image"></div>
                    <div class="service-card2_content" data-bg-src="assets/img/update1/bg/bg_pattern_5.png">
                        <h3 class="service-card2_title"><a href="solution7.html">安全态势实时展示</a>
                        </h3>
                        <p class="service-card2_text f14">
                            风险五色图动态展示企业安全态势，直观掌控，实时调整，确保安全防控。
                        </p>
                        <div class="service-card2_icon"><img src="assets/img/update1/icon/service_1_4.svg" alt="Icon">
                        </div>
                    </div><a href="solution7.html" class="service-card2_btn"><i class="far fa-long-arrow-right"></i></a>
                </div>
                <div class="service-card2">
                    <div class="service-card2_img"><img src="assets/img/update1/service/service_1_4_v2.jpg"
                            alt="service image"></div>
                    <div class="service-card2_content" data-bg-src="assets/img/update1/bg/bg_pattern_5.png">
                        <h3 class="service-card2_title"><a href="solution7.html">预警报警管理</a>
                        </h3>
                        <p class="service-card2_text f14">
                            未按期开展风险评估和隐患排查自动报警，推动双控体系健康运行，防患于未然。
                        </p>
                        <div class="service-card2_icon"><img src="assets/img/update1/icon/service_1_4.svg" alt="Icon">
                        </div>
                    </div><a href="solution7.html" class="service-card2_btn"><i class="far fa-long-arrow-right"></i></a>
                </div>
                <div class="service-card2">
                    <div class="service-card2_img"><img src="assets/img/update1/service/service_1_4_v2.jpg"
                            alt="service image"></div>
                    <div class="service-card2_content" data-bg-src="assets/img/update1/bg/bg_pattern_5.png">
                        <h3 class="service-card2_title"><a href="solution7.html">应急救援智能支撑</a>
                        </h3>
                        <p class="service-card2_text f14">
                            数字化应急预案库和语音播报系统，快速响应，科学指挥，减少事故损失。
                        </p>
                        <div class="service-card2_icon"><img src="assets/img/update1/icon/service_1_4.svg" alt="Icon">
                        </div>
                    </div><a href="solution7.html" class="service-card2_btn"><i class="far fa-long-arrow-right"></i></a>
                </div>
            </a-carousel>





        </div>
    </section>
    <section class="space-top" id="solution-home3">
        <div class="container" data-pos-space="#about-sec" data-sec-space="margin-bottom" data-margin-bottom="100px">
            <div class="title-area text-center">
                <div class="shadow-title">解决方案</div><span class="sub-title6 justify-content-center"><span
                        class="shape left"><span class="dots"></span></span> 解决方案三 <span class="shape right"><span
                            class="dots"></span></span></span>
                <h2 class="sec-title">作业风险智能管控与反违章平台</h2>
            </div>

            <a-carousel class="iconcarousel iconcarouselc" :slidesToShow="slidesToShow" :slidesToScroll="1"
                :arrows="!isMobile">
                <template #prevArrow>
                    <div class="custom-slick-arrow-left">
                        <left-outlined />
                    </div>
                </template>
                <template #nextArrow>
                    <div class="custom-slick-arrow-right">
                        <right-outlined />
                    </div>
                </template>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_2.svg"
                                    alt="Icon">
                            </div>
                            <h2 class="service-box2_title"><a href="solution8.html">实时作业监控</a>
                            </h2>
                            <p class="service-box2_text">
                                集成物联网设备和智能视频监控，实时采集作业现场数据，动态掌握人员位置、设备状态和环境参数。
                            </p>
                        </div><a href="solution8.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>

                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_3.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution8.html">智能风险识别与预警</a>
                            </h3>
                            <p class="service-box2_text">
                                人工智能技术对作业场景进行动态分析，精准识别潜在风险，多渠道实时预警，提供针对性整改建议。
                            </p>
                        </div><a href="solution8.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_4.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution8.html">违章行为智能抓拍
                                </a>
                            </h3>
                            <p class="service-box2_text">高精度AI算法自动检测未佩戴安全帽、危险区域闯入等违章行为，及时报警并记录数据，实现全流程闭环管理。
                            </p>
                        </div><a href="solution8.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_1.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution8.html">多维数据分析</a>
                            </h3>
                            <p class="service-box2_text">
                                基于大数据技术，自动生成违章行为统计和趋势分析，为安全管理决策提供数据支撑，优化管理流程。
                            </p>
                        </div><a href="solution8.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_2.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution8.html">施工机械管理</a>
                            </h3>
                            <p class="service-box2_text">
                                智能化管理融合物联网与AI技术，实时监测设备状态，预测故障、及时预警、优化设备调配。
                            </p>
                        </div><a href="solution8.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_3.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution8.html">智能穿戴设备深度集成</a>
                            </h3>
                            <p class="service-box2_text">
                                支持智能安全帽、智能手环、气体检测仪等设备，实时监测人员位置、健康状态及作业环境，动态调整作业策略。
                            </p>
                        </div><a href="solution8.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_3.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution8.html">电子围栏与闭锁管控</a>
                            </h3>
                            <p class="service-box2_text">
                                融合实时定位、AI识别及权限管控技术，精准管理危险区域，实时拦截无票作业，杜绝违规行为。
                            </p>
                        </div><a href="solution8.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_3.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution8.html">全场景应急响应支持</a>
                            </h3>
                            <p class="service-box2_text">
                                平台内置应急预案库，配合快速语音指挥系统，实时定位现场人员，科学应对突发事件，保障人员安全和作业连续性。
                            </p>
                        </div><a href="solution8.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
            </a-carousel>



        </div>

    </section>

    <section class="blog-area-5 overflow-hidden space" id="solution-home4">
        <div class="container">

            <div class="title-area text-center">
                <div class="shadow-title">解决方案</div><span class="sub-title6 justify-content-center"><span
                        class="shape left"><span class="dots"></span></span> 解决方案四 <span class="shape right"><span
                            class="dots"></span></span></span>
                <h2 class="sec-title">有限空间作业智能管控平台</h2>
            </div>


            <a-carousel class="iconcarousel iconcarouseld" :slidesToShow="slidesToShow" :slidesToScroll="1"
                :arrows="!isMobile">
                <template #prevArrow>
                    <div class="custom-slick-arrow-left">
                        <left-outlined />
                    </div>
                </template>
                <template #nextArrow>
                    <div class="custom-slick-arrow-right">
                        <right-outlined />
                    </div>
                </template>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="solution10.html"><img src="assets/img/blog/blog-5-1.jpg"
                                alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">实时环境与人员监测</h4>
                        <div class="blog-meta">联动气体检测仪、智能手环等设备，实时监测有限空间内的气体浓度、温湿度和人员健康状态，快速识别潜在风险。</div>
                        <a href="solution10.html" class="link-btn style2">了解更多<i
                                class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="solution10.html"><img src="assets/img/blog/blog-5-3.jpg"
                                alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">智能风险预警与闭锁管控</h4>
                        <div class="blog-meta">AI分析+闭锁管理功能，作业前自动审批与风险评估，作业中精准识别违规行为并预警，实现全面合规与安全。
                        </div>
                        <a href="solution10.html" class="link-btn style2">了解更多<i
                                class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="solution10.html"><img src="assets/img/blog/blog-5-4.jpg"
                                alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">全流程闭环管理</h4>
                        <div class="blog-meta">覆盖作业申请、审批、执行到终结的全流程管理，实现作业流程的电子化、标准化与透明化，降低人为操作失误。 </div>
                        <a href="solution10.html" class="link-btn style2">了解更多<i
                                class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="solution10.html"><img src="assets/img/blog/blog-5-2.jpg"
                                alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">离线模式支持</h4>
                        <div class="blog-meta">支持无网络环境作业，自动记录并离线保存数据，网络恢复后自动同步，保障偏远或封闭环境下的作业连续性。</div>
                        <a href="solution10.html" class="link-btn style2">了解更多<i
                                class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="solution10.html"><img src="assets/img/blog/blog-5-4.jpg"
                                alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">智能应急响应机制</h4>
                        <div class="blog-meta">实时监测异常状况，触发多渠道预警，快速启动应急预案，保障突发危险情况下作业人员的安全撤离与处理。</div>
                        <a href="solution10.html" class="link-btn style2">了解更多<i
                                class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="solution10.html"><img src="assets/img/blog/blog-5-2.jpg"
                                alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">安全态势展示</h4>
                        <div class="blog-meta">自动生成多维度安全分析报告，结合五色图等可视化工具展示作业安全态势。</div>
                        <a href="solution10.html" class="link-btn style2">了解更多<i
                                class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>

                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="solution10.html"><img src="assets/img/blog/blog-5-3.jpg"
                                alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">多设备数据协同</h4>
                        <div class="blog-meta">集成气体检测仪、智能手环、IP音柱等多种设备，统一监控、实时联动与集中管理，提高应急处理效率和系统可靠性。</div>
                        <a href="solution10.html" class="link-btn style2">了解更多<i
                                class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>


            </a-carousel>




        </div>
    </section>
    <section class="space bg-smoke overflow-hidden" id="solution-home5">
        <div class="shape-mockup service2-bg-shape1 jump" data-top="0" data-left="0"><img
                src="assets/img/service/service-bg-shape2-1.png" alt="img"></div>
        <div class="container">
            <div class="title-area text-center"><span class="sub-title2"><img class="me-1"
                        src="assets/img/icon/subtitle-img2-1.svg" alt="img">解决方案五</span>
                <h2 class="sec-title">智慧外包管控平台</h2>
            </div>


            <a-carousel class="iconcarousel iconcarousele" :slidesToShow="slidesToShow" :slidesToScroll="1"
                :arrows="!isMobile">
                <template #prevArrow>
                    <div class="custom-slick-arrow-left">
                        <left-outlined />
                    </div>
                </template>
                <template #nextArrow>
                    <div class="custom-slick-arrow-right">
                        <right-outlined />
                    </div>
                </template>

                <div class="col-md-6 col-lg-3">
                    <div class="service-card style2">
                        <div class="service-card-bg-img" data-bg-src="assets/img/service/service-2-1.png"></div>
                        <div class="service-content">
                            <div class="service-card-icon"><img src="assets/img/icon/service-icon-2-2.svg" alt="icon">
                            </div>
                            <h3 class="box-title"><a href="solution6.html">“一人一帽”智能管理</a></h3>

                        </div>
                        <p class="service-card-text">RFID技术实现外包人员与安全帽的唯一绑定，确保“人帽一致”，有效杜绝违规作业行为。</p><a
                            class="th-btn style10" href="solution6.html">了解更多<i class="fas fa-arrow-right ms-1"></i></a>
                        <div class="service-card-shape jump-reverse"><img
                                src="assets/img/service/service-card-bg-2-1.png" alt="img"></div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-3">
                    <div class="service-card style2">
                        <div class="service-card-bg-img" data-bg-src="assets/img/service/service-2-1.png"></div>
                        <div class="service-content">
                            <div class="service-card-icon"><img src="assets/img/icon/service-icon-2-1.svg" alt="icon">
                            </div>
                            <h3 class="box-title"><a href="solution6.html">智能门禁与准入授权</a></h3>

                        </div>
                        <p class="service-card-text">基于在线考试成绩和资质审核结果，系统自动完成门禁授权，实现人员进出权限精准管理、实时动态调整，杜绝未授权人员。</p><a
                            class="th-btn style10" href="solution6.html">了解更多 <i
                                class="fas fa-arrow-right ms-1"></i></a>
                        <div class="service-card-shape jump-reverse"><img
                                src="assets/img/service/service-card-bg-2-1.png" alt="img"></div>
                    </div>
                </div>


                <div class="col-md-6 col-lg-3">
                    <div class="service-card style2">
                        <div class="service-card-bg-img" data-bg-src="assets/img/service/service-2-1.png"></div>
                        <div class="service-content">
                            <div class="service-card-icon"><img src="assets/img/icon/service-icon-2-4.svg" alt="icon">
                            </div>
                            <h3 class="box-title"><a href="solution6.html">在线考试与培训管理</a></h3>

                        </div>
                        <p class="service-card-text">
                            支持企业定制化题库和在线考试，配合防作弊技术，培训内容精准匹配岗位需求，强化外包人员安全意识与技能。

                        </p><a class="th-btn style10" href="solution6.html">了解更多<i
                                class="fas fa-arrow-right ms-1"></i></a>
                        <div class="service-card-shape jump-reverse"><img
                                src="assets/img/service/service-card-bg-2-1.png" alt="img"></div>
                    </div>
                </div>


                <div class="col-md-6 col-lg-3">
                    <div class="service-card style2">
                        <div class="service-card-bg-img" data-bg-src="assets/img/service/service-2-1.png"></div>
                        <div class="service-content">
                            <div class="service-card-icon"><img src="assets/img/icon/service-icon-2-3.svg" alt="icon">
                            </div>
                            <h3 class="box-title"><a href="solution6.html">动态监控与智能预警</a></h3>

                        </div>
                        <p class="service-card-text">
                            集成人脸识别、AI算法与动态监控，实时掌握作业现场人员状态，快速识别违章行为和环境隐患，触发即时预警。
                        </p><a class="th-btn style10" href="solution6.html">了解更多<i
                                class="fas fa-arrow-right ms-1"></i></a>
                        <div class="service-card-shape jump-reverse"><img
                                src="assets/img/service/service-card-bg-2-1.png" alt="img"></div>
                    </div>
                </div>


                <div class="col-md-6 col-lg-3">
                    <div class="service-card style2">
                        <div class="service-card-bg-img" data-bg-src="assets/img/service/service-2-1.png"></div>
                        <div class="service-content">
                            <div class="service-card-icon"><img src="assets/img/icon/service-icon-2-3.svg" alt="icon">
                            </div>
                            <h3 class="box-title"><a href="solution6.html">高效审批与信息整合</a></h3>

                        </div>
                        <p class="service-card-text">
                            打通资质审核、门禁授权、动态监控的全流程，简化审批流程，实现外包单位与项目全生命周期管理。
                        </p><a class="th-btn style10" href="solution6.html">了解更多<i
                                class="fas fa-arrow-right ms-1"></i></a>
                        <div class="service-card-shape jump-reverse"><img
                                src="assets/img/service/service-card-bg-2-1.png" alt="img"></div>
                    </div>
                </div>



                <div class="col-md-6 col-lg-3">
                    <div class="service-card style2">
                        <div class="service-card-bg-img" data-bg-src="assets/img/service/service-2-1.png"></div>
                        <div class="service-content">
                            <div class="service-card-icon"><img src="assets/img/icon/service-icon-2-3.svg" alt="icon">
                            </div>
                            <h3 class="box-title"><a href="solution6.html">档案管理</a></h3>

                        </div>
                        <p class="service-card-text">
                            外包单位、人员资质的动态管理，提供快速查询与电子存储功能，为企业合规检查提供有力支持，提升管理透明度与可靠性。
                        </p><a class="th-btn style10" href="solution6.html">了解更多<i
                                class="fas fa-arrow-right ms-1"></i></a>
                        <div class="service-card-shape jump-reverse"><img
                                src="assets/img/service/service-card-bg-2-1.png" alt="img"></div>
                    </div>
                </div>



            </a-carousel>








        </div>
    </section>


    <section class="space-top" id="solution-home3">
        <div class="container" data-pos-space="#about-sec" data-sec-space="margin-bottom" data-margin-bottom="100px">
            <div class="title-area text-center">
                <div class="shadow-title">解决方案</div><span class="sub-title6 justify-content-center"><span
                        class="shape left"><span class="dots"></span></span> 解决方案六 <span class="shape right"><span
                            class="dots"></span></span></span>
                <h2 class="sec-title">智能两票管理系统</h2>
            </div>



            <a-carousel class="iconcarousel iconcarouselc" :slidesToShow="slidesToShow" :slidesToScroll="1"
                :arrows="!isMobile">
                <template #prevArrow>
                    <div class="custom-slick-arrow-left">
                        <left-outlined />
                    </div>
                </template>
                <template #nextArrow>
                    <div class="custom-slick-arrow-right">
                        <right-outlined />
                    </div>
                </template>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_2.svg"
                                    alt="Icon">
                            </div>
                            <h2 class="service-box2_title"><a href="solution5.html">全流程电子票据管理</a>
                            </h2>
                            <p class="service-box2_text">
                                工作票、操作票的全数字化管理，覆盖票据创建、审批、执行与归档流程，杜绝纸质票据带来的延误与误操作。
                            </p>
                        </div><a href="solution5.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>

                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_3.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution5.html"> 任务驱动的闭环管理</a>
                            </h3>
                            <p class="service-box2_text">
                                工单系统与票据系统深度联动，所有任务闭环管理，无任务不开票，无票不作业，全面规范作业流程，提升管理透明度。
                            </p>
                        </div><a href="solution5.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_4.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution5.html">实时数据联动与闭锁控制
                                </a>
                            </h3>
                            <p class="service-box2_text">集成SIS系统，实时采集设备状态，基于设备状态冲突自动闭锁，防止误操作、保障作业安全。
                            </p>
                        </div><a href="solution5.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_1.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution5.html">智能钥匙与接地线管理</a>
                            </h3>
                            <p class="service-box2_text">
                                实现对智能钥匙、接地线的动态管控，精准记录操作数据，保障设备操作规范性与区域安全。
                            </p>
                        </div><a href="solution5.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_2.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution5.html"> 多系统集成与协同</a>
                            </h3>
                            <p class="service-box2_text">
                                无缝集成智能门禁、视频监控、人员定位等系统，作业现场全方位监控与数据同步，提升应急响应能力与安全管理效能。

                            </p>
                        </div><a href="solution5.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_3.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution5.html">移动化操作实时反馈</a>
                            </h3>
                            <p class="service-box2_text">
                                支持移动端开票、审批与状态实时反馈，现场操作更灵活，确保任务执行高效、信息更新及时。
                            </p>
                        </div><a href="solution5.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                    <div class="service-box2" data-bg-src="assets/img/update1/bg/bg_pattern_14.png">
                        <div class="service-box2_content">
                            <div class="service-box2_icon"><img src="assets/img/update1/icon/service_3_3.svg"
                                    alt="Icon">
                            </div>
                            <h3 class="service-box2_title"><a href="solution5.html">合规性保障</a>
                            </h3>
                            <p class="service-box2_text">
                                系统自动记录所有票据与任务操作的日志，提供详细的审计报告与多媒体记录，全面满足监管需求。
                            </p>
                        </div><a href="solution5.html" data-bg-src="assets/img/update1/bg/service_btn_bg.jpg"
                            class="service-box2_btn">查看详情<i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>

            </a-carousel>

        </div>

    </section>

    <section class="blog-area-5 overflow-hidden space" id="solution-home4">
        <div class="container">

            <div class="title-area text-center">
                <div class="shadow-title">解决方案</div><span class="sub-title6 justify-content-center"><span
                        class="shape left"><span class="dots"></span></span> 解决方案七 <span class="shape right"><span
                            class="dots"></span></span></span>
                <h2 class="sec-title">行政精益化智能管控平台</h2>
            </div>


            <a-carousel class="iconcarousel iconcarouseld" :slidesToShow="slidesToShow" :slidesToScroll="1"
                :arrows="!isMobile">
                <template #prevArrow>
                    <div class="custom-slick-arrow-left">
                        <left-outlined />
                    </div>
                </template>
                <template #nextArrow>
                    <div class="custom-slick-arrow-right">
                        <right-outlined />
                    </div>
                </template>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="#"><img src="assets/img/blog/blog-5-1.jpg" alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">计划管理与精益执行</h4>
                        <div class="blog-meta">支持“一计划两清单”模式，将企业战略目标分解为年度重点计划和日常任务清单，动态追踪执行进度，实现计划从制定到完成的全流程闭环管理。</div>
                        <a href="#" class="link-btn style2">了解更多<i class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="#"><img src="assets/img/blog/blog-5-3.jpg" alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">任务管理与闭环控制</h4>
                        <div class="blog-meta">提供任务分解、优先级标记、动态提醒及执行验收功能，确保责任明确、实时追踪、高效完成。管理层可通过实时数据掌控任务进展，避免遗漏与延误。
                        </div>
                        <a href="#" class="link-btn style2">了解更多<i class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="#"><img src="assets/img/blog/blog-5-4.jpg" alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">收文管理关联任务</h4>
                        <div class="blog-meta">从收文登记到分发、审批及归档全流程数字化，自动联动文件、任务与计划，实时追踪落实情况，确保文件处理高效透明。 </div>
                        <a href="#" class="link-btn style2">了解更多<i class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="#"><img src="assets/img/blog/blog-5-2.jpg" alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">会议管理自动化</h4>
                        <div class="blog-meta">会议议题自动转化为任务分解，支持决策记录、追踪执行和闭环管理，优化会议决策效率，会议成果高效落地。</div>
                        <a href="#" class="link-btn style2">了解更多<i class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="#"><img src="assets/img/blog/blog-5-4.jpg" alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">智能应急响应机制</h4>
                        <div class="blog-meta">实时监测异常状况，触发多渠道预警，快速启动应急预案，保障突发危险情况下作业人员的安全撤离与处理。</div>
                        <a href="#" class="link-btn style2">了解更多<i class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>
                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="#"><img src="assets/img/blog/blog-5-2.jpg" alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">制度管理与版本可控</h4>
                        <div class="blog-meta">集中管理企业制度，支持快速检索、版本追溯及实时更新，确保制度的一致性与可追溯性，提升执行力与管理效率。</div>
                        <a href="#" class="link-btn style2">了解更多<i class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>

                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="#"><img src="assets/img/blog/blog-5-3.jpg" alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">跨模块数据互通</h4>
                        <div class="blog-meta">实现计划、任务、会议、收文等模块的数据实时共享与联动，为管理层提供全面工作视图，打破信息孤岛。</div>
                        <a href="#" class="link-btn style2">了解更多<i class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>

                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="#"><img src="assets/img/blog/blog-5-2.jpg" alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">智能数据分析</h4>
                        <div class="blog-meta">提供多维度数据分析和可视化工具，包括任务完成率、绩效对比和异常预警，助力管理层优化资源配置。</div>
                        <a href="#" class="link-btn style2">了解更多<i class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>


                <div class="th-blog blog-single style5">
                    <div class="blog-img"><a href="#"><img src="assets/img/blog/blog-5-4.jpg" alt="Blog Image"></a>

                    </div>
                    <div class="blog-content">
                        <h4 class="box-title">无缝集成与灵活配置</h4>
                        <div class="blog-meta">支持公有云与私有化部署，模块化设置灵活适配企业需求，可与ERP、OA系统深度集成，满足多行业、多场景管理要求。</div>
                        <a href="#" class="link-btn style2">了解更多<i class="fas fa-arrow-right ms-2"></i></a>
                    </div>
                </div>
            </a-carousel>





        </div>
    </section>
    <section class="space" id="homenews">
        <div class="container">
            <div class="title-area text-center"><span class="sub-title2"><img class="me-1"
                        src="assets/img/icon/subtitle-img2-1.svg" alt="img">News</span>
                <h2 class="sec-title">新闻资讯</h2>

            </div>
            <div class="blog-grid-wrap">
                <div class="blog-grid" v-for="item in newsList" :key="item.id">
                    <div class="blog-img">
                        <!-- <img :src="`assets/img/blog/${item.cardImage}`"> -->
                        <img :src="`${item.cardImage}`">
                        <div class="blog-date"><span>{{ item.day }}</span> {{ item.month }}
                        </div>
                    </div>
                    <div class="blog-content">
                        <!-- <div class="blog-meta"><a class="author" href="blog.html"><i
                                    class="fa-solid fa-user"></i>网站管理员</a>
                            <a href="blog.html"><i class="fa-solid fa-tags"></i>公司新闻</a>
                        </div> -->
                        <h3 class="blog-title">{{ item.title }}</h3>
                        <p class="blog-text blog-textlarge">{{ item.content }}</p>
                        <a href="#" @click.prevent="goToNewsView(item.id)" class="link-btn">浏览详情<i
                                class="flaticon-right-arrow"></i>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </section>
    <div id="Brands">
        <div class="container">
            <div class="bg-title z-index-common" data-pos-for=".testi-area-1" data-sec-pos="top-half">
                <div class="client-area-1">
                    <div class="row align-items-center">
                        <div class="col-lg-5">
                            <div class="title-area mb-lg-0 text-lg-start text-center">
                                <h2 class="sec-title text-white">重点客户名单</h2>
                                <p style="color:rgba(255,255,255,.4)">大唐思拓累计已为3个行业，200余家客户提供服务。</p>

                            </div>
                        </div>
                        <div class="col-lg-7">


                            <div class="row">
                                <div class="col-sm-4 col-lg-3"><a href="#" class="client-thumb"><img
                                            src="assets/img/client/cilent_1_2.png" alt="img"></a></div>
                                <div class="col-sm-4 col-lg-3"><a href="" class="client-thumb"><img
                                            src="assets/img/client/cilent_1_1.png" alt="img"></a></div>
                                <div class="col-sm-4 col-lg-3"><a href="" class="client-thumb"><img
                                            src="assets/img/client/cilent_1_3.png" alt="img"></a></div>
                                <div class="col-sm-4 col-lg-3"><a href="" class="client-thumb"><img
                                            src="assets/img/client/cilent_1_4.png" alt="img"></a></div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footer class="footer-wrapper footer-layout2"
        style="background-image: url(assets/img/bg/footer2-bg.png); padding-top: 120px;">
        <div class="widget-area space-top">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-md-6 col-xxl-5 col-xl-4">
                        <div class="widget footer-widget">
                            <div class="th-widget-about style2">
                                <div class="about-logo"><a href="index"><img src="assets/img/logo2.png" alt="img"></a>
                                </div>
                                <p class="about-text">
                                    大唐思拓是一家致力于推动客户实现高质量发展和高水平安全的智能安全管控专家。大唐思拓始终以先进的人工智能、大数据和物联网技术为核心动力，致力于以优质的产品和服务推动企业安全管理升级、智能化改造、经济增长和社会进步。依托于人工智能和数字化技术，大唐思拓专注于为企业提供简单易用、实用管用的智能化产品，帮助客户完成数字化转型，发展新质生产力，实现高质量发展和高水平安全。
                                </p>
                                <div class="footer-info-grid">
                                    <div class="footer-info-wrap">
                                        <h6 class="footer-info-title">咨询热线</h6>
                                        <div class="footer-info"><i class="fas fa-phone"></i> <a href="tel:4006988915"
                                                class="info-box_link">4006988915</a></div>
                                    </div>
                                    <div class="footer-info-wrap">
                                        <h6 class="footer-info-title">联系电话</h6>
                                        <div class="footer-info"><i class="fas fa-phone"></i> <a href="tel:01082051185"
                                                class="info-box_link">01082051185</a></div>
                                    </div>
                                </div>
                                <div class="footer-info-grid">
                                    <div class="footer-info-wrap">
                                        <h6 class="footer-info-title">微信公众号</h6>
                                        <div><img src="assets/img/code.jpg"></div>
                                    </div>
                                    <div class="footer-info-wrap">
                                        <h6 class="footer-info-title">微博官方号</h6>
                                        <div><img src="assets/img/weibo.jpg"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">解决方案</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">
                                    <li><a href="solution1.html">安全生产智慧管控方案</a></li>
                                    <li><a href="solution2.html">智慧安防高效解决方案</a></li>
                                    <li><a href="solution2b.html">安健环数字化管理解决方案</a></li>
                                    <li><a href="solution3.html">智慧工地一体解决方案</a></li>
                                    <li><a href="solution4.html">风机智慧定检解决方案</a></li>
                                    <li><a href="solution5.html">智能两票综合解决方案</a></li>
                                    <li><a href="solution6.html">智慧外包管理解决方案</a></li>
                                    <li><a href="solution7.html">双重预控智能管理方案</a></li>
                                    <li><a href="solution8.html">作业安全智能管控解决方案</a></li>
                                    <li><a href="solution9.html">智能锁控集成解决方案</a></li>
                                    <li><a href="solution10.html">有限空间作业智能管控方案</a></li>
                                    <li><a href="solution11.html">设备缺陷智能分析方案</a></li>
                                    <li><a href="solution12.html">在线考试管理解决方案</a></li>
                                    <li><a href="solution13.html">智慧食堂一体化解决方案</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">基础服务</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">
                                    <li><a href="product1.html">生产任务管理</a></li>
                                    <li><a href="product2.html">设备管理</a></li>
                                    <li><a href="product3.html">运行管理</a></li>
                                    <li><a href="product4.html">安全管理</a></li>
                                    <li><a href="product5.html">班组管理</a></li>
                                    <li><a href="product6.html">物资管理</a></li>
                                    <li><a href="product7.html">问题管理</a></li>
                                    <li><a href="product8.html">在线考试管理</a></li>
                                    <li><a href="product9.html">职业健康管理</a></li>
                                    <li><a href="product10.html">标准制度管理</a></li>
                                    <li><a href="product11.html">案例库管理</a></li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">增值服务</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">
                                    <li><a href="product12.html">智能两票管理</a></li>
                                    <li><a href="product13.html">智慧外包管理</a></li>
                                    <li><a href="product14.html">智能点检管理</a></li>
                                    <li><a href="product15.html">全员绩效管理</a></li>
                                    <li><a href="product16.html">风险评估管理</a></li>
                                    <li><a href="product17.html">安全生产责任制</a> </li>
                                </ul>
                            </div>
                        </div>
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">特色模块</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">
                                    <li><a href="product18.html">AI视频分析及预警</a></li>
                                    <li><a href="product19.html">实时定位和监控</a></li>
                                    <li><a href="product20.html">智能门禁管理</a></li>
                                    <li><a href="product21.html">智能锁控管理</a></li>
                                    <li><a href="product22.html">智能穿戴设备</a></li>
                                    <li><a href="product23.html">数据采集管理</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright-wrap">
            <div class="container">
                <div class="row justify-content-between align-items-center">
                    <div class="col-md-6">
                        <p class="copyright-text">Copyright © 2024 <strong>北京大唐思拓信息技术有限公司</strong> All Rights
                            Reserved.
                        </p>
                    </div>
                    <div class="col-md-6 text-end d-none d-md-block">
                        <div class="footer-links">
                            <ul>
                                <li><a href="about.html">京ICP备19044307号</a></li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>


    <div class="scroll-top"><svg class="progress-circle svg-content" width="100%" height="100%" viewbox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
                style="transition: stroke-dashoffset 10ms linear 0s; stroke-dasharray: 307.919, 307.919; stroke-dashoffset: 307.919;">
            </path>
        </svg></div>

    <div>
        <!-- 飘窗 -->
        <div v-if="isVisible" ref="floatingWindow" class="floating-window" :style="windowStyle"
            @mouseenter="pauseAnimation" @mouseleave="resumeAnimation"><a :href="linkUrl">
                <img :src="imageUrl" alt="">
            </a>
            <button @click="hideWindow">关闭</button>
        </div>
    </div>
</template>

<script setup>
import { LeftCircleOutlined, LeftOutlined, RightCircleOutlined, RightOutlined } from '@ant-design/icons-vue';
import { onBeforeUnmount, ref, computed, shallowRef, onMounted, onUnmounted, reactive } from 'vue';
import http from '@/shared/http.service';
import { Uris, DefaultConfig } from '@/shared/const';
import { Subject, from, EMPTY } from 'rxjs';
import { catchError, switchMap, throttleTime } from 'rxjs/operators';
import dayjs from 'dayjs';
import { useRouter } from 'vue-router';
import $ from 'jquery';

// 飘窗的可见性
const isVisible = ref(false); // 默认显示

// 飘窗的位置
const windowPosition = reactive({ x: 0, y: 0 });

// 飘窗的移动速度
const speed = reactive({ x: 1, y: 1 });

// 获取飘窗的 DOM 元素
const floatingWindow = ref(null);

// 飘窗的样式
const windowStyle = computed(() => ({
    left: `${windowPosition.x}px`,
    top: `${windowPosition.y}px`,
}));

// 隐藏飘窗
const hideWindow = () => {
    isVisible.value = false;
};
// 暂停动画
const pauseAnimation = () => {
    if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
    }
};

// 恢复动画
const resumeAnimation = () => {
    if (!animationFrameId) {
        startAnimation();
    }
};

// 更新飘窗位置
const updatePosition = () => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const windowElement = floatingWindow.value;

    if (windowElement) {
        // 计算新位置
        let newX = windowPosition.x + speed.x;
        let newY = windowPosition.y + speed.y;

        // 边界检测
        if (newX < 0 || newX + windowElement.offsetWidth > windowWidth) {
            speed.x = -speed.x; // 反向移动
        }
        if (newY < 0 || newY + windowElement.offsetHeight > windowHeight) {
            speed.y = -speed.y; // 反向移动
        }

        // 更新位置
        windowPosition.x = newX;
        windowPosition.y = newY;
    }
};

// 动画循环
let animationFrameId = null;
const startAnimation = () => {
    const animate = () => {
        updatePosition();
        animationFrameId = requestAnimationFrame(animate);
    };
    animate();
};


// 响应式数据
const isMobile = ref(false);

// 计算属性
const slidesToShow = computed(() => (isMobile.value ? 1 : 4));
const slidesToScroll = computed(() => 1);

// 方法：检测设备类型
const checkDeviceType = () => {
    isMobile.value = window.innerWidth < 468;
};
const imageUrl = ref();
const linkUrl = ref("notice.html");
onMounted(() => {
      http.get(Uris.GetIsShow, {   }).subscribe(v => {
    if (v) {
      if(v.isShow ==1){
        isVisible.value = true;
        imageUrl.value=`${window.serverConfig.baseUrl}/${v.imageUrl}`;
        linkUrl.value = v.linkUrl ?? linkUrl.value;
      }
    }
  });
    checkDeviceType(); // 初始化时检测设备类型
    window.addEventListener('resize', checkDeviceType); // 监听窗口大小变化
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const windowElement = floatingWindow.value;

    if (windowElement) {
        // 初始位置随机
        windowPosition.x = Math.random() * (windowWidth - windowElement.offsetWidth);
        windowPosition.y = Math.random() * (windowHeight - windowElement.offsetHeight);
    }

    // 启动动画
    startAnimation();

    document.title = '大唐思拓 - 智能安全专家 | 安全生产智能管控平台 | 安全生产管理系统 | 智慧电厂解决方案';
    const metaKeywords = document.createElement('meta');
    metaKeywords.name = 'keywords';
    metaKeywords.content = '大唐思拓,智能安全专家，安全生产智能管控平台,安全生产，安全管理，生产管理系统，安全生产管理，智能工厂，电厂生产管理系统，智慧电厂';
    document.head.appendChild(metaKeywords);
    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = '大唐思拓，智能安全专家，专注于安全生产智能管控平台建设，提供覆盖安全生产管理、智能工厂、电厂生产管理系统的全方位解决方案，助力企业实现智慧电厂的高效、安全运营。';
    document.head.appendChild(metaDescription);
    getNewsList(1);
});
const isActive = ref(false);
const toggleActive = () => {
    isActive.value = !isActive.value;
};

const newsList = ref([]);
const router = useRouter();

const pageList = reactive({
    total: 0,
    current: 1,
    pageSize: 3,//首页只获取三条新闻
    totalPageCount: 1
});



///获取新闻列表
const detail$ = new Subject();
const detailSubscription = detail$
    .pipe(
        switchMap((requestModel) => {
            return http.get(Uris.List, requestModel);
        }),
        catchError((err, caught) => {
            return caught;
        })
    )
    .subscribe(result => {

        if (!result.hasNextPage) {
            pageList.current = result.totalPageCount > 0 ? result.totalPageCount : 1;
        } else {
            pageList.current = result.pageIndex;
        }
        pageList.totalPageCount = result.totalPageCount;
        pageList.pageSize = result.pageSize;
        pageList.total = result.totalCount;

        result.list.forEach(element => {
            const model = {
                id: element.id,
                title: element.title,
                month: dayjs(element.stamp).format('MM'),
                day: dayjs(element.stamp).format('DD'),
                intro: element.intro,
                cardImage: `${window.serverConfig.baseUrl}/${element.cardImage}`,
            };
            newsList.value.push(model);
        });
    });

const getNewsList = (number) => {
    newsList.value = [];
    const requestModel = {
        pageIndex: number,
        pageSize: pageList.pageSize,
        orderBy: "stamp",
        direction: "Desc",
    };
    detail$.next(requestModel);
};

const goToNewsView = (id) => {
    // router.push({ name: 'newsview', params: { nid: id } });
    //router.push({ path: `/newsview/${id}` });
    window.open(`/newsview?id=${id}`, '_blank');
};
onBeforeUnmount(() => {
    window.removeEventListener('resize', checkDeviceType); // 组件销毁时移除监听
});

onUnmounted(() => {

    detailSubscription.unsubscribe();
    if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
    }
});

// 导入并在模板中使用组件
</script>
<style>
.footer-layout2 {
    padding-top: 120px;
}

.service-card2 {
    position: relative !important;
}

.service-card2_btn {
    bottom: 29px !important;
}

.service-card2_icon img {
    margin: auto;
    margin-top: 15px;
}

.th-hero-slide img:last-child {
    display: none;
}

#solution-home .service-box2_text {
    height: 120px;
    overflow: auto;
    text-align: justify;
}

.service-box2_title,
.service-card2_title {
    white-space: nowrap;
}

#solution-home2 .service-card2_text {
    text-align: justify;
    height: 150px;
    overflow: auto;
}

.service-card2_btn {
    height: 150px;
    line-height: 150px;
}

#solution-home3 .service-box2_text {
    text-align: justify;
    height: 100px;
}

#solution-home4 .box-title {
    white-space: nowrap;
}

#solution-home4 .blog-meta {
    height: 120px;
    text-align: justify;
}

#solution-home5 .service-card-text {
    height: 110px;
    overflow: hidden;
}

.service-card.style2 {
    height: 340px;
    overflow: hidden;
    padding: 20px;
}

.box-title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 20px !important;
}

.service-box2_title a,
.service-card2_title a {
    font-size: 20px !important;
}

.box-title a:hover {
    color: #000 !important;
}

.style2:hover .box-title {
    color: #000 !important;
}

#hero h1 {
    text-shadow: 0px 0px 15px rgba(0, 0, 0, 0.8);
}

.banner .slick-slide {
    text-align: center;
    height: 100vh;
    line-height: 100vh;
    background: #364d79;
    overflow: hidden;
    position: relative;
}

.banner .slick-arrow.custom-slick-arrow {
    width: 50px;
    height: 50px;
    font-size: 50px;
    color: #fff;
    background-color: rgba(31, 45, 61, 1);
    opacity: 0.3;
    z-index: 1;
    transition: all .3s;
}

.banner .custom-slick-arrow:before {
    display: none;
}

.banner .custom-slick-arrow:hover {
    width: 50px;
    height: 50px;
    font-size: 50px;
    color: #fff !important;
    background-color: rgba(31, 45, 61, .5) !important;
    opacity: 1;
    z-index: 9;
}

.banner .slick-slide h3 {
    color: #fff;
}

.slick-dots button:before {
    border: 0 !important
}

.banner .slick-slide>div>div {
    height: 100vh;
    box-sizing: border-box;
    position: relative;
    background-size: cover;
}

.banner .slick-slide>div>div::before {
    background-color: rgba(0, 0, 0, 0.6);
    height: 100%;
    width: 100%;
    content: "";
    position: absolute;
    left: 0;
    top: 0
}

.banner .slick-slide>div>div h3 {
    position: absolute;
    left: 0;
    top: 50%;
    height: 80px;
    margin-top: -40px;
    text-align: center;
    width: 100%;
    font-size: 60px;
    text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5)
}

.banner .slick-slide>div>div h3>p {
    color: #fff;
    font-size: 18px;
    text-transform: uppercase
}

.banner .slick-slide>div>div h3>div {
    padding-top: 10px;
}

.carousel1 {
    background-image: url(/src/assets/img/hero/hero_bg_4_5.jpg);
}

.carousel2 {
    background-image: url(/src/assets/img/hero/hero_bg_4_2.jpg);
}

.carousel3 {
    background-image: url(/src/assets/img/hero/hero_bg_4_1.jpg);
}

.carousel4 {
    background-image: url(/src/assets/img/hero/hero_bg_4_4.jpg);
}

.header-layout3 {
    width: 100% !important;
    position: fixed !important;
}

.header-layout3 .container {
    padding-left: 0 !important;
    padding-right: 0 !important;
    max-width: 100% !important;
}

#product-home {
    background-image: url(/src/assets/img/update1/bg/service_bg_3.jpg);
}

#solution-home2 {
    background-image: url(/src/assets/img/update1/bg/service_bg_1.png);
    padding-top: 200px!important;
}

.th-carousel {
    margin-bottom: -70px;
}

.footer-layout2:after {
    width: 800px !important;
}

#jjfa {
    width: 560px;

}

#jjfa li a {
    white-space: nowrap;
}

@media(max-width: 575px) {
    #jjfa {
        width: auto;

    }

    .header-layout3 .header-top {
        background-color: #000 !important;
    }

    .banner>div>div h3 {
        font-size: 36px;
    }

    .banner>div>div h3>p {
        font-size: 14px;
    }
}

.iconcarousel {
    height: 420px;
    margin-bottom: -120px;
}


.iconcarousel .slick-slide>div>div {
    height: 420px;
    position: initial;
}

.iconcarousel .slick-slide>div>div::before {
    display: none;
}

.iconcarousel .slick-slide {
    height: 420px;
    overflow: hidden;
    padding: 10px;

}

.iconcarouselb {
    margin-bottom: 0px;
}

.iconcarouselc {
    margin-bottom: -138px;
}

.iconcarouseld {
    margin-bottom: 0px;
}

.iconcarousele {
    margin-bottom: 0px;
}

.iconcarouselb .slick-dots {
    bottom: -10px;
}

.iconcarouselc .slick-dots {
    bottom: 40px;
}

.iconcarouseld .slick-dots {
    bottom: -40px;
}

.iconcarousele .slick-dots {
    bottom: 40px;
}

.iconcarousel .slick-arrow.custom-slick-arrow-left,
.iconcarousel .slick-arrow.custom-slick-arrow-right {
    width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    text-align: center;
    display: inline-block;
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    border: 1px #999 solid;
    color: #000;
    opacity: 0.3;
    z-index: 1;
    transition: all .3s;
}

.iconcarousel .slick-arrow.custom-slick-arrow-left {
    left: -30px;
}

.iconcarousel .slick-arrow.custom-slick-arrow-right {
    right: -30px;
}

.iconcarousel .custom-slick-arrow-left:before,
.iconcarousel .custom-slick-arrow-right:before {
    display: none;
}

.iconcarousel .custom-slick-arrow-left:hover,
.iconcarousel .custom-slick-arrow-right:hover {
    opacity: 1;
    border: 1px #201a87 solid;
    z-index: 9;
}

.iconcarousel .slick-dots li button {
    background-color: #999;
}

.iconcarousel .slick-dots li.slick-active button {
    background-color: #201a87;
}


.floating-window {
    position: fixed;
    background-color: white;
    width: 300px;
    height: 200px;
    box-sizing: border-box;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    overflow: hidden;
    border-radius: 10px;
    transition: all 0.1s linear;
    box-shadow: 0px 0px 50px rgba(255, 0, 0, 0.5);
    /* 平滑移动 */
}

.floating-window a,
.floating-window a img {
    display: block;
    width: 100%;
    height: 100%;
}

.floating-window button {
    position: absolute;
    right: 0;
    top: 0PX;
    background-color: transparent;
    color: #000;
    border: none;
    cursor: pointer;
    font-size: 12px;
}

.floating-window button:hover {
    background-color: #d32f2f;
}

#homenews div.blog-img img {
    width: 300px;
    height: 100%;
    overflow: hidden;
    object-fit:cover;
}
#homenews .blog-grid:nth-child(1) img
{width: 100%; height: 275px;}
</style>